import { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export default function Login({ setIsLoggedIn }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  function authenticate(e) {
    e.preventDefault();

    fetch(`${process.env.REACT_APP_API_BASE_URL}/users/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,
        password: password,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);

        if (data.access) {
          localStorage.setItem("token", data.access);
          setIsLoggedIn(true);
          Swal.fire({
            title: "Login Successful",
            icon: "success",
            text: "Welcome to Fitness Tracker!",
          });

          navigate("/");
        } else {
          Swal.fire({
            title: "Login Failed",
            icon: "error",
            text: "Invalid email or password",
          });
        }
      })
      .catch((error) => {
        console.error("Login Error:", error);
        Swal.fire({
          title: "Error",
          icon: "error",
          text: "Failed to log in. Please try again.",
        });
      });

    setEmail("");
    setPassword("");
  }

  return (
    <Container fluid className="registration-container bg-register">
      <Row className="center  mt-5">
        <Col
          md={{ span: 8, offset: 2 }}
          className="d-flex align-items-center justify-content-center"
        >
          <div className="registration-form-wrapper">
            <h1 className="mb-5 text-center">Login</h1>
            <Form onSubmit={authenticate}>
              <Form.Group controlId="userEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group controlId="password">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </Form.Group>

              <Button
                variant="secondary"
                type="submit"
                id="submitBtn"
                className="text-center mt-3"
              >
                Submit
              </Button>
            </Form>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
